const satV3Zone = '/sat-v3-zone';

export const routes = {
  base: satV3Zone,
  test: `${satV3Zone}/test`,

  // Dashboard
  dashboard: `${satV3Zone}/dashboard`,

  // School Setup
  schoolSetup: {
    structure: `${satV3Zone}/school-setup/structure`,
    day: `${satV3Zone}/school-setup/day`,
    calendar: `${satV3Zone}/school-setup/calendar`,
  },

  // People
  people: {
    teachers: `${satV3Zone}/people/teachers`,
    students: `${satV3Zone}/people/students`,
    roles: `${satV3Zone}/people/roles`,
  },

  // Curriculum
  curriculum: {
    subjects: `${satV3Zone}/curriculum/subjects`,
    plans: `${satV3Zone}/curriculum/plans`,
    groupings: `${satV3Zone}/curriculum/groupings`,
  },

  // Rules
  rules: {
    hard: `${satV3Zone}/rules/hard`,
    soft: `${satV3Zone}/rules/soft`,
    preferences: `${satV3Zone}/rules/preferences`,
    teacherPreferences: `${satV3Zone}/rules/teacher-preferences`,
    profiles: `${satV3Zone}/rules/profiles`,
  },

  // Generator
  generator: {
    generate: `${satV3Zone}/generator/generate`,
    history: `${satV3Zone}/generator/history`,
    settings: `${satV3Zone}/generator/settings`,
  },

  // Timetable
  timetable: {
    view: `${satV3Zone}/timetable/view`,
    edit: `${satV3Zone}/timetable/edit`,
    conflicts: `${satV3Zone}/timetable/conflicts`,
  },

  // Simulations
  simulations: `${satV3Zone}/simulations`,

  // Versions
  versions: {
    history: `${satV3Zone}/versions/history`,
    finalize: `${satV3Zone}/versions/finalize`,
  },

  // Export
  export: {
    timetables: `${satV3Zone}/export/timetables`,
    preview: `${satV3Zone}/export/preview`,
  },

  unauthorized: '/403',
  notFound: '/not-found',
};

export function toRelativePath(absolutePath: string, baseName = '/sat-v3-zone'): string {
  let relative = absolutePath;

  if (absolutePath === baseName) return '';

  if (absolutePath.startsWith(baseName)) {
    // Remove the baseName portion
    relative = absolutePath.substring(baseName.length);
  }

  // If there's a leading '/', strip it out so the returned path doesn't start with '/'
  return relative.startsWith('/') ? relative.substring(1) : relative;
}
